import axios from "axios";
import rutas from "@/assets/utils/rutas.json";
import { normalizeProcedimientoCode } from "../helpers/procedimientoCodeMapper";

const getAll = async (params = {}) => {
  const {
    search,
    establecimiento,
    especialidad,
    excel,
    pdf,
    fechaDesde,
    fechaHasta,
    page,
    pageSize,
    estado,
    observaciones,
  } = params;

  const query = `
    query qrallProcedimientoclinico(
      $busqueda        : String,
      $establecimiento : String,
      $especialidad    : String, 
      $page            : Int,
      $pageSize        : Int
      $excel           : String, 
      $pdf             : String,
      $fechadesde      : String,
      $fechahasta      : String,
      $estado          : String,
      $observaciones   : String
    ){
      allProcedimientoclinico(
        busqueda       : $busqueda,
        establecimiento: $establecimiento,
        especialidad   : $especialidad, 
        excel          : $excel, 
        pdf            : $pdf, 
        page           : $page, 
        pageSize       : $pageSize, 
        fechadesde     : $fechadesde, 
        fechahasta     : $fechahasta, 
        estado         : $estado,
        observaciones  : $observaciones
      ) {
        proclinic {
          id
          token
          fechaProgramada
          estadoProceso
          urlMspPaciente
          urlMspTitular1
          urlMspTitular2
          urlMspTitular3
          doctorRealiza{
          id
          especialidad{
          id
          descripcion
          }
          idPersona{
          primerNombre
          primerApellido
          identificacion}
          }
          consultamedica{
            cita{
              id
              fechaCita
              detallescitaSet
              {
              detailsSeguro
              detallesTitulares
              }
              cobSeleccionada{
                id
                descripcion
              }
              establecimiento{
                Descripcion
              }
              paciente {
                id
                numHistoriaClinica
                persona {
                  identificacion
                  primerNombre
                  segundoNombre
                  primerApellido
                  segundoApellido
                }
                segsalud{
                  descripcion
                }
              }
              doctor{
                id
                idPersona{
                  primerNombre
                  segundoNombre
                  primerApellido
                  segundoApellido
                }
                especialidad{
                  descripcion
                }
              }
            }
          }
          procedimiento{
            codigo
            descripcion
            especialidad{
              descripcion
            }
          }
          procedimientoOdonto{
          id
          codigo
            descripcion
          }
        }
        dataarchivo
        total
        status
        message
        sinMsp
      }
    }
  `;

  const variables = {
    busqueda: search,
    establecimiento: establecimiento,
    especialidad: especialidad,
    excel: excel,
    pdf: pdf,
    page: page,
    pageSize: pageSize,
    fechadesde: fechaDesde,
    fechahasta: fechaHasta,
    estado: estado,
    observaciones: observaciones,
  };

  try {
    const response = await axios.post(rutas.axios + "api", {
      query,
      variables,
    });
    if (response.status !== 200) return null;

    const response2 = response.data.data.allProcedimientoclinico;
    if (response2.status !== "success") return null;

    const data = {
      data: response2.proclinic,
      total: response2.total,
      sinMsp: response2.sinMsp,
      blob: response2.dataarchivo,
    };

    return data;
  } catch (error) {
    console.error("Error al obtener los procedimientos", error);
    return null;
  }
};

const getByAtencion = async (tokenAtencion) => {
  if (!tokenAtencion) {
    console.error("token atencion es requerido");
    return null;
  }

  const query = `
    query AllAtenmedica($tokenAtencion: String) {
      allAtenmedica(tokenAtencion: $tokenAtencion) {
        total
        status
        message
        atcm {
          id
          token
          procedimientocitaSet{
            id
            token
            estado
            procedimiento{
              id
              descripcion
              codigo
            }
              procedimientoOdonto{
              id
            codigo
            descripcion
           
          }
            noas400
            motivoSolicitud
            resumenClinico
            justificacion
            estadoProceso
          }
        }
      }
    }
  `;

  const variables = { tokenAtencion };

  try {
    const response = await axios.post(rutas.axios + "api", {
      query,
      variables,
    });
    const response2 = response.data.data.allAtenmedica;

    if (response2.status !== "success") return null;
    if (response2.atcm.length === 0) return null;
    if (response2.atcm[0].procedimientocitaSet.length === 0) return null;

    const data = response2.atcm[0].procedimientocitaSet;
    const dataActiva = data.filter((i) => i.estado === "1");
    return dataActiva;
  } catch (error) {
    console.log("Error al obtener procedimientos de la atencion", error);
    return null;
  }
};
const searchByQueryOdonto = async (search = "", establecimiento = "0") => {
  const query = `
            query GetAllitemOdontologicos($search: String, $establecimiento: String) {
                allOdonto(search: $search, establecimiento: $establecimiento) {
                    total
                    status
                    message
                    itemOdontologico{
                        id
                        token
                        descripcion
                        establecimiento
                      	especialidad {
                          id
                          descripcion
                        }
                        usuarioCreador {
                            id
                            username
                        }
                        codigo
                        estado
                        precio
                        precioJson
                        estadoJson
                    }
                    pageInfo {
                        currentPage
                        totalPages
                        hasNextPage
                        hasPreviousPage
                    }
                }
            }

            `;
  const var_consulta = {
    search: search,
    establecimiento: establecimiento,
  };

  console.log("variables que envio", var_consulta);
  try {
    const response = await axios.post(rutas.axios + "api", {
      query,
      variables: var_consulta,
    });
    console.log(response);

    if (response.status === 200) {
      if (response.data.data.allOdonto.status === "Success") {
        if (response.data.data.allOdonto.itemOdontologico) {
          return response.data.data.allOdonto.itemOdontologico.map((item) => ({
            value: item.id,
            text: `(${item.codigo}) ${item.descripcion}`,
            cod: item.codigo,
          }));
        } else {
          console.log("No se encontraron itemOdontologicos");
          // Aquí podrías establecer un mensaje en la interfaz de usuario
        }
      } else {
        console.log("Error en la respuesta del servidor");
        // Manejo del error de respuesta del servidor
      }
    }
  } catch (error) {
    console.error("Error fetching itemOdontologico:", error);
    // Aquí también podrías mostrar un mensaje de error en la interfaz de usuario
  }
};

const searchByQuery = async (searchQuery = "", establecimiento = "0") => {
  const query = `
    query MyQuery(
      $search: String!
      $establecimiento: String
    ) {
      allProcs(
        search: $search
        establecimiento: $establecimiento
      ) {
        message
        status
        total
        totalSns
        procedimiento {
          codigo
          descripcion
          precio
          id
          estado
          establecimiento
        }
        procedimientosSns {
          id
          codigo
          descripcion
        }
      }
    }
  `;

  const variables = {
    search: searchQuery,
    establecimiento,
  };

  try {
    const response = await axios.post(rutas.axios + "api", {
      query,
      variables,
    });

    const allProcs = response.data?.data?.allProcs || {};
    const procedimientos = (allProcs.procedimiento || []).map((item) => ({
      value: item.id,
      text: `(${item.codigo}) ${item.descripcion}`,
      cod: item.codigo,
    }));

    const procedimientosSns = (allProcs.procedimientosSns || []).map(
      (item) => ({
        value: `sns-${item.id}`,
        text: `(${item.codigo}) ${item.descripcion} [SNS]`,
        cod: item.codigo,
      })
    );

    return [...procedimientos, ...procedimientosSns];
  } catch (error) {
    console.error("Error fetching procedimientos:", error.response?.data || error);
    return error;
  }
};

const getByToken = async (tokenProceso) => {
  if (!tokenProceso) return null;

  const query = `
    query qrallProcedimientoclinico($tokenProceso: String) {
      allProcedimientoclinico( tokenProceso: $tokenProceso ) {
        proclinic {
          id
          token
          fechaProgramada
          estadoProceso
          urlMspPaciente
          urlMspTitular1
          urlMspTitular2
          consultamedica{
            cita{
            id
              establecimiento{
                Descripcion
              }
              paciente {
                id
                persona {
                  identificacion
                  primerNombre
                  segundoNombre
                  primerApellido
                  segundoApellido
                }
              }
            }
          }
          procedimiento{
            codigo
            descripcion
            especialidad{
              descripcion
            }
          }
             procedimientoOdonto{
            codigo
            descripcion
           
          }
        }
        dataarchivo
        total
        status
        message
      }
    }
  `;

  const variables = {
    tokenProceso,
  };

  try {
    const response = await axios.post(rutas.axios + "api", {
      query,
      variables,
    });
    if (response.status !== 200) return null;

    const response2 = response.data.data.allProcedimientoclinico;
    if (response2.status !== "success") return null;

    const data = response2.proclinic[0];
    return data;
  } catch (error) {
    console.error("Error fetching laboratorio:", error);
  }
};

const getSignosByTokenProc = async (tokenProcedimiento) => {
  if (!tokenProcedimiento) return null;

  const query = `
    query getSignosTokenProc($tokenProcedimiento: String!) {
      getSignosTokenProc( tokenProcedimiento: $tokenProcedimiento ) {
       id
       temperatura
       peso
       tensionArterialSistolica
       tensionArterialDiastolica
       imc
       pulso
       freqRespiratoria
       satOxigeno
       perimetroCefalico
       talla
       perimetroAbdominal
                 
      }
    }
  `;

  const variables = {
    tokenProcedimiento,
  };

  try {
    const response = await axios.post(rutas.axios + "api", {
      query,
      variables,
    });
    if (response.status !== 200) return null;

    const response2 = response.data.data.getSignosTokenProc;

    return response2;
  } catch (error) {
    console.error("Error fetching laboratorio:", error);
  }
};

const getDataAtencionByTokenProc = async (tokenProcedimiento) => {
  if (!tokenProcedimiento) return null;

  const query = `
    query getDataAtencionTokenProc($tokenProcedimiento: String!) {
      getDataAtencionTokenProc( tokenProcedimiento: $tokenProcedimiento ) {
        atencion {
            id
            fechaCreacion
            ultimoCambio
            token
            estadoRev
            comentarioValidacion
            signature
            urlConsentimiento
            estado
            horainicio
            semiologia
            cita {
            fechaCita
            codderivacion
            }
            anamnesisSet {
                id
                fechaCreacion
                ultimoCambio
                token
                estado
                motivoConsulta
                problemaActual
                ptratamiento
                semiologia
                obsadicionalAp
                obsadicionalAf
                obsadicionalRo
                obsadicionalEf
            }
            anteperanamSet {
                id
                fechaCreacion
                ultimoCambio
                token
                descripcionGeneral
                anio
                estado
                antescedentesPersonales {
                    id
                    fechaCreacion
                    ultimoCambio
                    token
                    descripcion
                    tipoAntecedente
                    estado
                }
            }
            antefamanamSet {
                id
                fechaCreacion
                ultimoCambio
                token
                descripcionGeneral
                familiar
                estado
                antescedentesFamiliares {
                    id
                    fechaCreacion
                    ultimoCambio
                    token
                    descripcion
                    tipoAntecedente
                    estado
                }
            }
            revorganamSet {
                id
                fechaCreacion
                ultimoCambio
                token
                descripcionGeneral
                estado
                revisionorganos {
                    id
                    fechaCreacion
                    ultimoCambio
                    token
                    descripcion
                    estado
                }
            }
            exafisanamSet {
                id
                fechaCreacion
                ultimoCambio
                token
                descripcionGeneral
                estado
                examenfisico {
                    id
                    fechaCreacion
                    ultimoCambio
                    token
                    descripcion
                    tipoExamen
                    estado
                }
            }
            diaganamSet {
                id
                fechaCreacion
                ultimoCambio
                token
                esprincipal
                estado
                diagnostico {
                    id
                    fechaCreacion
                    ultimoCambio
                    token
                    descripcion
                    codigo
                    estado
                }
            }
        }
        status
        message
    }
}

  `;

  const variables = {
    tokenProcedimiento,
  };

  try {
    const response = await axios.post(rutas.axios + "api", {
      query,
      variables,
    });
    if (response.status !== 200) return null;

    let objeto = {
      aFamiliares: null,
      aPersonales: null,
      cuadroClinico: null,
      cita: null,
      exFisico: null,
      revOrganos: null,
      diagnosticos: [],
    };

    const response2 = response.data.data.getDataAtencionTokenProc;
    console.log("response 2", response2);
    if (response2.atencion) {
      let antefam = response2.atencion.antefamanamSet;
      let anteper = response2.atencion.anteperanamSet;
      let diagnosticos = response2.atencion.diaganamSet;
      let exafis = response2.atencion.exafisanamSet;
      let anamnesis = response2.atencion.anamnesisSet;
      let revorg = response2.atencion.revorganamSet;

      objeto.cita = response2.atencion.cita;

      if (anteper.length > 0) {
        let text = [];
        anteper.forEach((e) => {
          let anio = e.anio ? `(${e.anio})` : "";
          text.push(
            `${e.antescedentesPersonales.descripcion} ${anio} : ${e.descripcionGeneral} `
          );
        });
        objeto.aPersonales = text.join(", ");
      }
      if (antefam.length > 0) {
        let text = [];
        anteper.forEach((e) => {
          if (e.antescedentesFamiliares) {
            let familiar = e.familiar ? `(${e.familiar})` : "";
            text.push(
              `${e.antescedentesFamiliares.descripcion} ${familiar} : ${e.descripcionGeneral} `
            );
          }
        });
        objeto.aFamiliares = text.join(", ");
      }
      if (exafis.length > 0) {
        let text = {};
        exafis.forEach((e) => {
          if (e.examenfisico.descripcion === "TÓRAX") {
            text.torax = e.descripcionGeneral;
          }
          if (e.examenfisico.descripcion === "ABDOMEN") {
            text.abdomen = e.descripcionGeneral;
          }
          if (e.examenfisico.descripcion === "NEUROLÓGICO") {
            text.neurologico = e.descripcionGeneral;
          }
          if (e.examenfisico.id === "17") {
            text.corazon = e.descripcionGeneral;
          }
          if (e.examenfisico.descripcion === "RESPIRATORIO") {
            text.pulmones = e.descripcionGeneral;
          }
        });
        objeto.exFisico = text;
      }
      if (diagnosticos.length > 0) {
        let text = [];
        diagnosticos.forEach((e) => {
          text.push({
            diagnostico: `(${e.diagnostico.codigo}) ${e.diagnostico.descripcion} `,
            diagObject: {
              value: e.diagnostico.id,
              text: `(${e.diagnostico.codigo}) ${e.diagnostico.descripcion} `,
              codigo: e.diagnostico.codigo,
              descripcion: e.diagnostico.descripcion,
            },
          });
        });
        objeto.diagnosticos = text;
      }
      if (anamnesis.length > 0) {
        objeto.cuadroClinico = `${anamnesis[0].problemaActual}, ${anamnesis[0].motivoConsulta}`;
      }
    }

    return objeto;
  } catch (error) {
    console.error("Error fetching laboratorio:", error);
  }
};

const searchSns = async (search) => {
  const query = `
    query AllProcedimientosSns(
      $search:String
    ) {
      allProcedimientosSns(
        search:$search
      ) {
        status
        total
        message
        procedimientos {
          id
          token
          codigo
          descripcion
        }
      }
    }
  `;

  const variables = {
    search,
  };

  try {
    const response = await axios.post(rutas.axios + "api", {
      query,
      variables,
    });
    console.log("response sns procedimientos", response);

    if (response.status !== 200) return null;
    const response2 = response.data.data.allProcedimientosSns;
    if (response2.status !== "success") return null;
    const data = response2.procedimientos;

    const dataMap = data.map((item) => ({
      codigo: item.codigo,
      value: item.id,
      text: `${item.codigo} - ${item.descripcion}`,
    }));

    return dataMap;
  } catch (error) {
    console.error("Error al buscar procedimientos sns", error);
    return null;
  }
};

const updateByToken = async (tokenProceso, fieldsToUpdate) => {
  if (!tokenProceso) return null;

  const query = `
    mutation UpdateProcesoEnviado(
      $tokenProcesoEnviado: String!
      $fieldsToUpdate: ProcesoFieldsToUpdate!
    ) {
      updateProcesoEnviado(
        tokenProcesoEnviado : $tokenProcesoEnviado
        fieldsToUpdate      : $fieldsToUpdate
      ) {
        status
        message
        procesoActualizado
      }
    }
  `;

  const variables = {
    tokenProcesoEnviado: tokenProceso,
    fieldsToUpdate: { ...fieldsToUpdate },
  };

  try {
    const response = await axios.post(rutas.axios + "api", {
      query,
      variables,
    });
    if (response.status !== 200) return null;

    const response2 = response.data.data.updateProcesoEnviado;
    if (response2.status !== "success") return null;

    const data = response2.procesoActualizado;
    return data;
  } catch (error) {
    console.error("Error al obtener los procedimientos", error);
    return null;
  }
};

const registerProcesos = async (tokenAtencion, dataProcesos) => {
  if (!tokenAtencion) {
    console.error("id atencion es requerido");
    return null;
  }

  if (!dataProcesos || dataProcesos.length === 0) {
    console.error("dataProcesos es requerido");
    return null;
  }

  const query = `
    mutation crearProcedimientoCita(
      $procedimientos: String!,
      $tokenAtencion: String!,
    ){ 
      crearProcedimientoCita(
        procedimientos: $procedimientos
        tokenAtencion: $tokenAtencion
      ){
        procita {
          id
          token
        }
        status,
        message
      }
    }
  `;

  const variables = {
    procedimientos: JSON.stringify(dataProcesos),
    tokenAtencion,
  };

  try {
    const response = await axios.post(rutas.axios + "api", {
      query,
      variables,
    });
    if (response.status !== 200) return null;

    const response2 = response.data.data.crearProcedimientoCita;
    if (response2.status !== "success") return null;

    const data = response2.procita;
    return data;
  } catch (error) {
    console.error("Error al registrar los procesos", error);
    return null;
  }
};

const processEnvios = async (tokenAtencion, procedimientosToProcess) => {
  // asi deben ser los procesos a enviar
  // [{
  //   "action"          :"crear",
  //   "procedimientoId" :"10",
  //   "numeroOrden"     :"3231313",
  //   "motivoSolicitud" :"aaa",
  //   "resumenClinico"  :"bbb",
  //   "justificacion"   :"cccc"
  // }]

  console.log("EDITAR PROCESS ENVIOS", procedimientosToProcess)

  const query = `
    mutation ProcessEnvioProcedimientos(
      $tokenAtencion:String!
      $procedimientosToProcess:[ProcessEnvioProcedimientosInput]!
    ) {
      processEnvioProcedimientos(
        tokenAtencion: $tokenAtencion
        procedimientosToProcess:$procedimientosToProcess
      ) {
        status
        procedimientos
        message
      }
    }
  `;

  const variables = {
    tokenAtencion,
    procedimientosToProcess,
  };

  try {
    const response = await axios.post(rutas.axios + "api", {
      query,
      variables,
    });
    if (response.status !== 200) return null;

    const response2 = response.data.data.processEnvioProcedimientos;
    if (response2.status !== "success") return null;

    const data = response2.procedimientos;
    return data;
  } catch (error) {
    console.error("Error al registrar los procesos", error);
    return null;
  }
};

const ejecutarProcesoByToken = async (tokenProceso, doctor, accion) => {
  if (!tokenProceso) {
    return null;
  }

  const query = ` 
    mutation ejecutarProcesoClinico(
      $tokenProceso: String!,
      $doctor: ID,
      $accion: String!
      
    ) {
      ejecutarProcesoClinico(
        tokenProceso : $tokenProceso,
        doctor: $doctor,
        accion: $accion       
      ) {
        status
        message
        proceso {
        id
        }
      
      }
    }
  `;

  const variables = {
    tokenProceso: tokenProceso,
    doctor: doctor?.value,
    accion: accion,
  };

  try {
    const response = await axios.post(rutas.axios + "api", {
      query,
      variables,
    });
    if (response.status !== 200) return null;

    const response2 = response.data.data.ejecutarProcesoClinico;
    // Devolver siempre la respuesta para poder mostrar mensajes de error del backend
    console.log("response ejecutarProcesoClinico", response2);
    return response2;
  } catch (error) {
    console.error("Error al obtener los procedimientos", error);
    return null;
  }
};

const obtenerAsistenciaProc = async (tokenProceso) => {
  if (!tokenProceso) return null;

  const query = `
  query generateAsistenciaProcedimientoPdf($tokenProceso: String!) {
    generateAsistenciaProcedimientoPdf(tokenProceso: $tokenProceso)
  }
`;

  const variables = {
    tokenProceso,
  };

  try {
    const response = await axios.post(rutas.axios + "api", {
      query,
      variables,
    });

    if (response.status !== 200) return null;

    const response2 = response.data.data.generateAsistenciaProcedimientoPdf;
    console.log(response2);

    const data = response2;
    if (!data) return null;

    return data;
  } catch (error) {
    console.error("Error fetchinng formularios de procedimientos:", error);
    return null;
  }
};

const obtenerDataBaseConsentimiento = async (codProcedimiento, descripcion = "") => {
  if (!codProcedimiento) return null;

  const normalizedCode = normalizeProcedimientoCode(codProcedimiento, descripcion);

  const query = `
  query obtainDataConsentimiento($codProcedimiento: String, $idFormulario: String) {
    obtainDataConsentimiento(codProcedimiento: $codProcedimiento, idFormulario: $idFormulario){
    id
    dataJson
    }
  }
`;

  const variables = {
    codProcedimiento: normalizedCode,
    idFormulario: "024",
  };

  try {
    const response = await axios.post(rutas.axios + "api", {
      query,
      variables,
    });

    if (response.status !== 200) return null;

    const response2 = response.data?.data?.obtainDataConsentimiento;
    const dataJsonString = response2?.dataJson;
    if (!dataJsonString) return null;

    let dataJson = null;
    try {
      dataJson = JSON.parse(dataJsonString);
    } catch (parseError) {
      console.error("Error parsing dataJson consentimiento:", parseError);
      return null;
    }

    if (!dataJson) return null;

    return dataJson;
  } catch (error) {
    console.error("Error fetchinng formularios de procedimientos:", error);
    return null;
  }
};

export const procedimientosService = {
  getAll,
  getByAtencion,
  searchByQuery,
  registerProcesos,
  getByToken,
  searchSns,
  getSignosByTokenProc,
  processEnvios,
  updateByToken,
  ejecutarProcesoByToken,
  obtenerAsistenciaProc,
  getDataAtencionByTokenProc,
  obtenerDataBaseConsentimiento,
  searchByQueryOdonto,
};
